import { pickEnum, pickNumber, pickString } from "@/lib/search-params";

export const ADMIN_USER_IDENTITIES = ["all", "member", "guest"] as const;
export const ADMIN_USER_ROLES = ["all", "user", "admin"] as const;
export const ADMIN_USER_STATUSES = ["all", "active", "banned"] as const;
export const ADMIN_USER_SORTS = [
  "created_desc",
  "created_asc",
  "name_asc",
  "name_desc",
  "email_asc",
  "email_desc",
] as const;

export interface AdminUserListSearch {
  identity: (typeof ADMIN_USER_IDENTITIES)[number];
  limit: number;
  offset: number;
  q?: string;
  role: (typeof ADMIN_USER_ROLES)[number];
  sort: (typeof ADMIN_USER_SORTS)[number];
  status: (typeof ADMIN_USER_STATUSES)[number];
}

export function validateAdminUserListSearch(raw: Record<string, unknown>): AdminUserListSearch {
  const limit = Math.min(100, Math.max(1, Math.floor(pickNumber(raw.limit) ?? 25)));
  const offset = Math.max(0, Math.floor(pickNumber(raw.offset) ?? 0));

  return {
    identity: pickEnum(raw.identity, ADMIN_USER_IDENTITIES, "all"),
    limit,
    offset,
    q: pickString(raw.q),
    role: pickEnum(raw.role, ADMIN_USER_ROLES, "all"),
    sort: pickEnum(raw.sort, ADMIN_USER_SORTS, "created_desc"),
    status: pickEnum(raw.status, ADMIN_USER_STATUSES, "all"),
  };
}
